var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSessionTimer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.93,
    height: 55.077,
    viewBox: "0 0 82.93 55.077",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28897",
    "data-name": "Group 28897",
    transform: "translate(-878.915 -439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28883",
    "data-name": "Group 28883",
    transform: "translate(878.506 445.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18166",
    "data-name": "Rectangle 18166",
    transform: "translate(0.409 0.222)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 48,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 47,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18167",
    "data-name": "Rectangle 18167",
    transform: "translate(0.409 0.222)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0H61a4,4,0,0,1,4,4V7a0,0,0,0,1,0,0H0A0,0,0,0,1,0,7V4A4,4,0,0,1,4,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,.5H61A3.5,3.5,0,0,1,64.5,4V6a.5.5,0,0,1-.5.5H1A.5.5,0,0,1,.5,6V4A3.5,3.5,0,0,1,4,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1337",
    "data-name": "Ellipse 1337",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(4.409 2.222)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1338",
    "data-name": "Ellipse 1338",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(6.409 2.222)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1339",
    "data-name": "Ellipse 1339",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(9.409 2.222)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18168",
    "data-name": "Rectangle 18168",
    width: 48,
    height: 4,
    rx: 1,
    transform: "translate(8.409 12.222)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18169",
    "data-name": "Rectangle 18169",
    width: 48,
    height: 3,
    rx: 1,
    transform: "translate(8.409 22.222)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18170",
    "data-name": "Rectangle 18170",
    width: 48,
    height: 4,
    rx: 1,
    transform: "translate(8.409 29.222)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18171",
    "data-name": "Rectangle 18171",
    width: 48,
    height: 3,
    rx: 1,
    transform: "translate(8.409 37.222)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28884",
    "data-name": "Group 28884",
    transform: "translate(930.661 439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hourglass",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(0 1.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(0.035 0.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M140.526,110.238a11.919,11.919,0,0,0,.392,13.049c1.805,2.5,4.514,4.168,6.665,6.373s3.784,5.454,2.649,8.318c-1.155,2.915-4.54,4.1-7.074,5.947a13.371,13.371,0,0,0-3.225,18.263h26.326s4.624-8.813-1.321-15.53-9.139-6.827-8.918-11.231,3.3-5.836,5.065-7.487,10.35-5.505,5.285-17.7Z",
    transform: "translate(-137.666 -110.238)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M140.332,110.082s.153,0,.453,0l1.335,0,5.137-.007,18.917-.014h.019l.007.018a24.528,24.528,0,0,1,.981,2.851,16.613,16.613,0,0,1,.559,3.1,12.3,12.3,0,0,1-.167,3.27,10.507,10.507,0,0,1-1.19,3.179,11.589,11.589,0,0,1-.992,1.439,13.416,13.416,0,0,1-1.213,1.3,17.9,17.9,0,0,1-1.377,1.165c-.479.371-.979.721-1.467,1.091-.245.184-.468.391-.7.6s-.475.4-.719.594c-.486.389-.978.778-1.442,1.2a7.7,7.7,0,0,0-2.162,3.1,7.533,7.533,0,0,0-.412,1.9c-.013.163-.035.325-.041.489s-.012.327,0,.491a5.6,5.6,0,0,0,.1.98,4.472,4.472,0,0,0,.79,1.8,10,10,0,0,0,1.365,1.478c1,.914,2.06,1.786,3.075,2.728s2.011,1.925,2.966,2.965a17.881,17.881,0,0,1,1.369,1.628,11.424,11.424,0,0,1,1.1,1.84,12.077,12.077,0,0,1,1.134,4.175,15.294,15.294,0,0,1-.256,4.389,18.027,18.027,0,0,1-.565,2.153,15.7,15.7,0,0,1-.836,2.08l-.011.021h-.7l-25.648,0h-.021l-.011-.017a13.573,13.573,0,0,1-2.2-6.214,13.1,13.1,0,0,1,.911-6.272,13.655,13.655,0,0,1,3.48-4.97,15.8,15.8,0,0,1,2.376-1.733c.822-.51,1.651-.982,2.434-1.5a11.154,11.154,0,0,0,2.143-1.743,5.855,5.855,0,0,0,1.326-2.3,5.716,5.716,0,0,0,.1-2.566,8.356,8.356,0,0,0-.814-2.359,11.533,11.533,0,0,0-1.325-2.013,16.035,16.035,0,0,0-1.6-1.673c-1.114-1.026-2.255-1.923-3.281-2.845-.514-.46-1-.924-1.45-1.4a13.067,13.067,0,0,1-1.2-1.481,11.287,11.287,0,0,1-1.506-3.122,11.656,11.656,0,0,1-.513-2.957c-.022-.23-.013-.455-.013-.676s0-.435.019-.644.032-.413.047-.611.056-.389.083-.575a10.982,10.982,0,0,1,1.032-3.278,4.411,4.411,0,0,1,.238-.459l.189-.322c.1-.172.154-.259.154-.259l-.149.264-.185.323a4.5,4.5,0,0,0-.234.459,11.053,11.053,0,0,0-1.019,3.277c-.026.186-.058.377-.081.574s-.03.4-.045.61-.015.423-.018.642-.008.445.014.674a11.634,11.634,0,0,0,.517,2.947,11.259,11.259,0,0,0,1.505,3.108,13.032,13.032,0,0,0,1.2,1.475c.448.475.935.938,1.448,1.4,1.026.92,2.168,1.815,3.285,2.842a16.1,16.1,0,0,1,1.611,1.677,11.593,11.593,0,0,1,1.333,2.021,8.418,8.418,0,0,1,.821,2.375,5.781,5.781,0,0,1-.1,2.593,5.919,5.919,0,0,1-1.339,2.325,11.207,11.207,0,0,1-2.154,1.755c-.786.518-1.615.991-2.435,1.5a15.751,15.751,0,0,0-2.365,1.727,13.589,13.589,0,0,0-3.459,4.947,13.029,13.029,0,0,0-.9,6.238,13.5,13.5,0,0,0,2.194,6.178l-.032-.017,25.648,0h.678l-.036.022a15.644,15.644,0,0,0,.831-2.067,17.966,17.966,0,0,0,.562-2.143,15.218,15.218,0,0,0,.255-4.366,12,12,0,0,0-1.126-4.148,11.361,11.361,0,0,0-1.1-1.828,17.8,17.8,0,0,0-1.363-1.621q-1.429-1.557-2.96-2.96c-1.014-.941-2.072-1.812-3.074-2.729a10.09,10.09,0,0,1-1.375-1.49,4.551,4.551,0,0,1-.8-1.833,5.686,5.686,0,0,1-.1-.992c-.008-.166,0-.331,0-.5s.028-.329.041-.493a7.612,7.612,0,0,1,.416-1.914,7.773,7.773,0,0,1,2.183-3.129c.467-.428.96-.818,1.446-1.207.243-.194.484-.39.717-.591s.458-.416.7-.6c.491-.371.99-.72,1.468-1.09a17.819,17.819,0,0,0,1.372-1.16,13.373,13.373,0,0,0,1.207-1.29,11.514,11.514,0,0,0,.986-1.429,10.439,10.439,0,0,0,1.184-3.158,12.235,12.235,0,0,0,.168-3.253,16.546,16.546,0,0,0-.555-3.087,24.426,24.426,0,0,0-.976-2.844l.026.018-18.906-.014-5.141-.007-1.338,0C140.487,110.085,140.332,110.082,140.332,110.082Z",
    transform: "translate(-137.436 -110.054)",
    stroke: "#000",
    strokeWidth: 0.25
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(7.001 17.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M199.969,207.649c-2,1.551-6.375,5.115-7.326,7.448-1.08,2.648-.279,5.624-.8,8.287a.375.375,0,0,1-.741-.078,28.532,28.532,0,0,0-.314-5.217,12.484,12.484,0,0,0-3.1-6.645c-1.412-1.46-3.265-2.431-4.771-3.8-1.085-.983,3.634,1.865,8.576,1.763C196.5,209.31,201.724,206.291,199.969,207.649Z",
    transform: "translate(-182.761 -207.299)",
    fill: "#c8d0de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(1.425 41.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M173.269,369.525A3.046,3.046,0,0,0,172.052,367a2.4,2.4,0,0,0-1.727-.1c-.571.15-1.107.41-1.673.578a5.483,5.483,0,0,1-3.424-.108,21.036,21.036,0,0,1-2.932-1.634,4.5,4.5,0,0,0-3.208-.688c-1.875.467-2.851,2.724-4.705,3.269a5.1,5.1,0,0,1-2.547-.084,9.934,9.934,0,0,0-2.537-.4,2.814,2.814,0,0,0-1.844.719l0-.007-.014.015a1.916,1.916,0,0,0-.213.249,3.483,3.483,0,0,0-.49,2.734,9.772,9.772,0,0,0,1.213,2.945A8.672,8.672,0,0,0,150.3,377.4c1.262.9,2.85.279,4.4.4a72.806,72.806,0,0,0,11.087.2c1.9-.148,3.689.059,5.2-1.109a6.143,6.143,0,0,0,2.088-3.362A11.5,11.5,0,0,0,173.269,369.525Z",
    transform: "translate(-146.664 -364.966)",
    fill: "#c8d0de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(0.369 53.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M139.826,443.986a2.087,2.087,0,0,1,1.5-1.881h27.69s1.444.731,1.621,1.856Z",
    transform: "translate(-139.826 -442.105)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(2.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M178.915,99.812l-.044.02-26.036-.168s-.092-.059-.231-.167a.987.987,0,0,1,.616-1.764l25.27.2A.987.987,0,0,1,178.915,99.812Z",
    transform: "translate(-152.223 -97.733)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(12.092 19.657)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M193.314,173.487c.021.034-.058.108-.208.22s-.371.267-.651.457a8.645,8.645,0,0,1-1.057.628,4.69,4.69,0,0,1-.725.28,3.9,3.9,0,0,1-.417.1,3.247,3.247,0,0,1-.45.049,2.823,2.823,0,0,1-.9-.1,3.528,3.528,0,0,1-.727-.313c-.209-.117-.389-.232-.559-.343s-.323-.217-.461-.318c-.551-.4-.841-.7-.785-.755s.448.129,1.056.444l.5.257c.178.091.37.192.565.286a3.458,3.458,0,0,0,.613.233,2.3,2.3,0,0,0,.675.067,4.09,4.09,0,0,0,1.343-.326c.4-.167.765-.355,1.08-.5a5.942,5.942,0,0,1,.779-.32C193.174,173.465,193.294,173.454,193.314,173.487Z",
    transform: "translate(-186.362 -173.376)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(15.085 36.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M235.365,334.15a.439.439,0,1,1-.022.009",
    transform: "translate(-235.091 -334.129)",
    fill: "#f2ac9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(2.383 4.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M156.525,138.965a.794.794,0,0,1-.092-.093l-.252-.277c-.107-.123-.247-.264-.39-.446l-.492-.612c-.168-.237-.358-.493-.55-.777l-.282-.449c-.048-.078-.1-.154-.146-.236l-.136-.251a10.419,10.419,0,0,1-.959-2.309,9.7,9.7,0,0,1-.364-2.475c0-.193.01-.38.014-.563,0-.091,0-.181.012-.269l.028-.26c.019-.17.033-.335.056-.492l.081-.45c.044-.288.12-.541.175-.765.03-.112.053-.217.082-.311l.084-.257.119-.355a.782.782,0,0,1,.047-.122.819.819,0,0,1-.031.127l-.1.359-.077.259c-.027.095-.048.2-.076.312-.05.225-.122.477-.162.765l-.076.448c-.021.157-.033.321-.051.49l-.025.258c-.008.088-.006.177-.01.268,0,.181-.013.368-.011.559a9.825,9.825,0,0,0,.367,2.454,10.566,10.566,0,0,0,.947,2.3l.134.25c.045.081.1.158.143.236l.277.449c.188.284.376.54.54.779l.481.617c.14.184.276.328.379.454l.241.286A.807.807,0,0,1,156.525,138.965Z",
    transform: "translate(-152.862 -127.197)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(4.58 21.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M167.085,254.206a.3.3,0,0,1,.029-.051l.092-.145.152-.235.1-.15c.038-.051.083-.1.127-.159l.3-.37c.119-.128.255-.261.4-.407a10.7,10.7,0,0,1,1.06-.892c.82-.622,1.878-1.239,3.024-1.96a17.419,17.419,0,0,0,1.734-1.222,8.152,8.152,0,0,0,1.556-1.645,7.78,7.78,0,0,0,1.258-4.145,9.817,9.817,0,0,0-.592-3.521,13.13,13.13,0,0,0-1.023-2.194c-.143-.248-.261-.437-.342-.565l-.091-.146a.3.3,0,0,1-.029-.051.321.321,0,0,1,.036.047l.1.141c.085.125.207.311.355.557a12.564,12.564,0,0,1,1.05,2.191,9.777,9.777,0,0,1,.613,3.542,8.064,8.064,0,0,1-.085,1.042,7.618,7.618,0,0,1-.226,1.067,7.278,7.278,0,0,1-.954,2.079,8.184,8.184,0,0,1-1.573,1.661,17.251,17.251,0,0,1-1.744,1.223c-1.151.719-2.209,1.33-3.03,1.943a10.991,10.991,0,0,0-1.063.879c-.143.144-.281.274-.4.4l-.307.364c-.046.055-.091.105-.13.156l-.1.147-.158.23-.1.141A.333.333,0,0,1,167.085,254.206Z",
    transform: "translate(-167.085 -236.35)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(1.834 41.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M150.619,369.613a.3.3,0,0,1-.034.072l-.11.2c-.05.084-.109.188-.168.313s-.138.263-.2.425l-.109.251c-.037.088-.068.182-.1.278-.076.191-.134.4-.2.622a8.348,8.348,0,0,0-.272,2.969c.026.229.045.447.084.649.018.1.031.2.052.292l.061.267c.034.171.085.321.122.454s.075.247.109.339l.072.213a.293.293,0,0,1,.02.076.285.285,0,0,1-.035-.07l-.087-.209a3.269,3.269,0,0,1-.122-.336c-.042-.133-.1-.283-.135-.454l-.067-.268c-.023-.093-.037-.192-.057-.294-.043-.2-.065-.423-.092-.653a8.06,8.06,0,0,1,.275-3c.069-.222.131-.434.21-.626.038-.1.07-.191.109-.278l.114-.251c.069-.162.15-.3.215-.422a3.269,3.269,0,0,1,.181-.308l.123-.189A.283.283,0,0,1,150.619,369.613Z",
    transform: "translate(-149.31 -369.612)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341",
    transform: "translate(8.083 45.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M203.074,393.645a.144.144,0,0,1-.031.023l-.1.06-.375.225-.272.161c-.1.056-.215.109-.335.17-.243.117-.513.266-.831.387l-.494.2c-.172.069-.358.123-.547.188-.376.137-.792.235-1.227.349a14.423,14.423,0,0,1-5.81.152c-.44-.091-.861-.167-1.244-.284-.192-.055-.38-.1-.556-.159l-.5-.177c-.324-.1-.6-.238-.85-.343-.123-.055-.24-.1-.344-.152l-.28-.147-.386-.205-.1-.055a.138.138,0,0,1-.032-.021.146.146,0,0,1,.036.014l.1.048.392.192.282.14c.1.048.222.093.346.145.25.1.527.231.851.331l.5.171c.175.058.363.1.555.154.382.114.8.187,1.239.275a14.648,14.648,0,0,0,5.78-.151c.433-.111.848-.206,1.223-.34.188-.064.374-.115.546-.182l.493-.2c.318-.116.589-.261.833-.374.121-.059.236-.11.337-.163l.275-.155.382-.212.1-.053A.142.142,0,0,1,203.074,393.645Z",
    transform: "translate(-188.761 -393.645)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(12.617 19.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M200.834,182.005l-.013.012-.041.034-.159.127c-.138.109-.339.268-.592.457a8.59,8.59,0,0,1-.926.612,4.215,4.215,0,0,1-.6.274,2.718,2.718,0,0,1-.688.153,2.621,2.621,0,0,1-1.322-.275,4.509,4.509,0,0,1-.511-.3c-.152-.107-.291-.211-.414-.311-.247-.2-.44-.365-.574-.48l-.154-.133-.04-.035-.013-.013.015.01.042.033.158.128c.137.112.332.277.58.472.123.1.263.2.414.306a4.574,4.574,0,0,0,.509.3,2.608,2.608,0,0,0,1.307.27,2.7,2.7,0,0,0,.68-.151,4.237,4.237,0,0,0,.593-.271,8.909,8.909,0,0,0,.927-.6c.254-.186.457-.343.6-.449l.163-.122.043-.031Z",
    transform: "translate(-194.793 -182.005)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345",
    transform: "translate(10.076 46.19)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M201.664,399.257a3.25,3.25,0,0,1,2.665-.238,8.057,8.057,0,0,0,2.732.372c.69-.1,1.323-.436,2-.584a1.775,1.775,0,0,1,1.885.547,14.674,14.674,0,0,1-9.288-.1",
    transform: "translate(-201.664 -398.748)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionTimer);
export default __webpack_public_path__ + "static/media/sessionTimer.8a9ae8c2bbe148cf4cfdfab900585950.svg";
export { ForwardRef as ReactComponent };